/* eslint-disable no-console */
/* eslint-disable no-return-assign */
/**
 * 会话列表组件
 * 放弃dva
 * 实现：
 *  加载所有会话列表， 可以分类展示
 *  接收会话更新，新增，删除事件，进行移除元素，新增元素等
 *  抛出接收到的事件， 会话组件接收事件
 *  排序会话列表
 * @author sunzhiguang
 * @date 2020/6/16
 */

import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import ChatState, { UserState } from "@/types/chat/State";
import { useTranslation } from "react-i18next";

import {
  MessageCategoryType,
  MessageNotifyType,
  MessageTimeCategory,
  MessageTypeCategory
} from "@/types/chat/enum";
import { Session, SessionProps } from "@/types/chat";
import SessionCategory from "@/components/chat/SessionCategory";
import NoDataTips from "./noData";
import { connect } from "dva";
import "./index.less";
import { CompDataLoadState, DefaultPageType } from "@/models";
import {
  messageNotifyTypeConditionMap,
  sessionConditionMap
} from "@/components/chat/SessionList/common";
import Context from "@/components/chat/context";
import Bus from "@/utils/bus";
import {
  isAINoticeChildSession,
  isAINoticeSession,
  isCustomAppSession,
  isSYSNoticeSession
} from "@/utils/chat/session";
import { usePrevious } from "@/utils/chat/index";
import sentryManual from "@/utils/sentryManual";
import { isFocusEnv } from "@/utils";
import { reportWebPerf } from "@/utils/logAnalytics";
import {
  computeAITimestamp
} from "@/utils/chat/message";

interface props {
  allSessionList: SessionProps[] | null;
  selectedSession: Session;
  showSessionTopAll: any;
  reSortAllSessionList: Function;
  updatePageLoadState: Function;
  setSessionScrollIndex: Function;
  customAppList: Session[];
  topUpLayoutMode?: "horizon" | "vertical";
}

type IChatLeftProps = Readonly<ChatState & UserState & props>;

export enum sessionItem {
  height = 62
}

function SessionList(this: any, props: IChatLeftProps) {
  const {
    atCount,
    unReadCount,
    selectedNotifyType,
    selectedCategory,
    showSessionTopAll,
    sessionStatusMap,
    updatePageLoadState,
    loadAllSessionListEnd,
    allSessionList,
    selectedSession,
    sessionScrollIndex,
    sessionUnReadList,
    setSessionScrollIndex,
    aiNoticeSessionList,
    customAppList,
    topUpModeCustom = "horizon"
  } = props;
  const { currentEmployee } = React.useContext(Context);
  const { t } = useTranslation("chat");
  const preIndex = usePrevious(sessionScrollIndex);
  const scrollref: any = document.getElementById("chat-left-scroll")?.firstChild;
  useEffect(() => {
    if (!loadAllSessionListEnd) {
      return;
    }
    // performance.measure('db-create-time', 'db-create-start', 'db-create-end');
    // performance.measure('im-login-time', 'im-login-start', 'im-login-end');
    // performance.measure(
    //     'get-all-sessions-time',
    //     'get-all-sessions-start',
    //     'get-all-sessions-end'
    // );
    // performance.measure('get-auth-info-time', 'get-auth-info-start', 'get-auth-info-end');
    // performance.measure('im-get-instance-time', 'im-get-instance-start', 'im-get-instance-end');
    // performance.measure('total-time', 'get-auth-info-start', 'get-all-sessions-end');
    // let measures = performance.getEntriesByType('measure');

    // measures.forEach((measure) => {
    //     console.log(measure.name + ': ' + measure.duration);
    // });

    Bus.emit("app:default-page-init");
    if (selectedNotifyType === MessageNotifyType.IMPORTANT) {
      if (atCount === 0) {
        // 没有人@你
        Bus.emit("app:default-page-nodata", DefaultPageType.AT);
      }
    } else if (selectedNotifyType === MessageNotifyType.UNREAD) {
      if (unReadCount === 0) {
        // 暂无新消息
        Bus.emit("app:default-page-nodata", DefaultPageType.MESSAGE);
      }
    } else if (selectedNotifyType === MessageNotifyType.REMIND) {
      if (unReadCount === 0) {
        Bus.emit("app:default-page-nodata", DefaultPageType.MESSAGE);
      }
    } else if (selectedNotifyType === MessageNotifyType.GROUPS) {
      if (unReadCount === 0) {
        Bus.emit("app:default-page-nodata", DefaultPageType.MESSAGE);
      }
    } else if (selectedNotifyType === MessageNotifyType.ALL) {
      if (allSessionList?.length === 0) {
        // 暂无会话
        Bus.emit("app:default-page-nodata", DefaultPageType.SESSION);
      }
    }
  }, [allSessionList, loadAllSessionListEnd, updatePageLoadState, selectedNotifyType]); // eslint-disable-line
  useEffect(() => {
    if (!allSessionList) {
      updatePageLoadState({
        rightLoadState: CompDataLoadState.INIT,
        rightPageType: null
      });
      return;
    }
    if (allSessionList.length === 0) {
      // 暂无会话
      updatePageLoadState({
        rightLoadState: CompDataLoadState.NODATA,
        rightPageType: DefaultPageType.SESSION
      });
    } else if (allSessionList.length > 0) {
      updatePageLoadState({
        rightLoadState: CompDataLoadState.INIT,
        rightPageType: null
      });
    }
  }, [allSessionList, allSessionList.length, updatePageLoadState]);

  // const sessionNodeList = useMemo(() => {
  //     if (!allSessionList) {
  //         return [];
  //     }
  //     console.log('sessionNodeList  11==>');
  //     return allSessionList.map((s, index) => {
  //         return {
  //             session: s,
  //             SessionNode: <SessionNode session={s} index={index} last={false} />,
  //         };
  //     });
  // }, [allSessionList]);

  useEffect(() => {
    const sessionUnReadCount = sessionUnReadList.length;
    if (sessionUnReadCount === 1 && preIndex === sessionScrollIndex) {
      setSessionScrollIndex({ sessionScrollIndex: -1 });
    }

    if (sessionScrollIndex === -1 || !sessionUnReadCount || preIndex === sessionScrollIndex) {
      return;
    }
    const { id, index } = sessionUnReadList[sessionScrollIndex];
    if (!id || index === -1) {
      return;
    }
    if (scrollref) {
      scrollref.scrollTop = sessionItem.height * index;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionScrollIndex, preIndex, sessionUnReadList, setSessionScrollIndex]);

  useEffect(() => {
    try {
      // 网页端增加性能埋点
      if (allSessionList?.length && window.performance) {
        if (performance.getEntriesByName("domResponseEnd")?.length) {
          performance.mark("sessionLoadEnd");
          performance.measure("customTTI", "domResponseEnd", "sessionLoadEnd");
          const customTTI = performance.getEntriesByName("customTTI")[0]?.duration?.toFixed(2);
          const {
            navigationStart,
            responseEnd,
            domContentLoadedEventEnd
          } = window.performance.timing;
          const domLoadTime = responseEnd - navigationStart;
          console.log("customTTI", customTTI, domLoadTime);
          sentryManual.captureMessage(
            `customTTI: ${customTTI}, domLoadTime: ${domLoadTime}`,
            "performance"
          );
          reportWebPerf({
            sta_ts: navigationStart,
            htm_ts: responseEnd,
            dom_ts: domContentLoadedEventEnd,
            end_ts: Date.now()
          });
          performance.clearMarks();
          performance.clearMeasures();
        }
      }
    } catch (e) {
      console.log(e);
    }
  }, [allSessionList]);

  const isTopSessionOrNotDeleted = (session: Session) => {  
    if(topUpModeCustom === "horizon"){
      return session.del === 0;
    }else{
      return ((session?.settings?.top || 0 ) > 0) || session.del === 0;
    }
  }

  const aiSessionTimestamp = useMemo(() => {
    return computeAITimestamp(aiNoticeSessionList);
  }, [aiNoticeSessionList]);

  const getCategorySessionList = useCallback(
    (type: string) => {
      if (!allSessionList || (allSessionList || []).length === 0) {
        return [];
      }  
      if (topUpModeCustom === "vertical") {
        // AI助手置顶情况下默认第一位展示【不再默认第一位】
      // const aiSessionIndex = allSessionList.findIndex((item: Session) => isAINoticeSession(item));
      // if (aiSessionIndex > -1 && ((allSessionList[aiSessionIndex].settings || {}).top || 0) > 0) {
      //   const [aiSessionItem] = allSessionList.splice(aiSessionIndex, 1);
      //   // 将AI助手日期默认改为今天，以便置顶
      //   aiSessionItem.timestamp = Date.now();
      //   allSessionList.splice(0, 0, aiSessionItem);
      // }
      // 先把除AI助手外的notice类型的session过滤掉1756280662590. 1756276241529
      return allSessionList
      .filter((session) => { // 过滤非置顶且del：1的会话
        return isTopSessionOrNotDeleted(session)
      })
        .filter((session) =>
          selectedNotifyType === MessageNotifyType.REMIND
            ? isCustomAppSession(session, customAppList)
            : !isAINoticeChildSession(session, customAppList)
        )
        .filter((session) => {
          let unreadCount = 0;
          aiNoticeSessionList.forEach((item) => {
            unreadCount += item.unreadCount || 0;
          });
          const a = sessionConditionMap[type](session);
          const b = messageNotifyTypeConditionMap[selectedNotifyType](
            session,
            currentEmployee,
            unreadCount
          );
          return a && b;
        });
      }else {
      // 先把除AI助手外的notice类型的session过滤掉
      const filteredSessionList = allSessionList
      .filter((session) => { // 过滤非置顶且del：1的会话
         return isTopSessionOrNotDeleted(session)
      })
        .filter((session) =>
          selectedNotifyType === MessageNotifyType.REMIND
            ? isCustomAppSession(session, customAppList)
            : !isAINoticeChildSession(session, customAppList)
        )
        .filter((session) => {
          let unreadCount = 0;
          aiNoticeSessionList.forEach((item) => {
            unreadCount += item.unreadCount || 0;
          });
          const a = sessionConditionMap[type](session);
          const b = messageNotifyTypeConditionMap[selectedNotifyType](
            session,
            currentEmployee,
            unreadCount
          );
          return a && b;
        });
        // 横向置顶模式，按照最后一条消息整体逆序排序
        filteredSessionList.forEach(item => {
          if(isAINoticeSession(item)){
            // 系统通知类的会话，按照最后一条消息时间排序
            item.timestamp = aiSessionTimestamp;
          }
        })
        // const topSession = filteredSessionList.filter((item: SessionProps) => (item?.settings?.top || 0) > 0);
        // const noTopSession = filteredSessionList.filter((item: SessionProps) => !(item?.settings?.top || 0) > 0);
        const timeOrderedList = filteredSessionList.sort((a, b) => {
          return b.timestamp - a.timestamp;
        })
        // console.log("getAllSessionList===timeOrderedList", timeOrderedList.map(i => {
        //   return {
        //     name: i.info.name,
        //     sessionId: i.sessionId,
        //     del: i.del,
        //     settings: i.settings,
        //     timestamp: i.timestamp,
        //     lastMsg: i.lastMsg
        //   }
        // }));  
        return timeOrderedList;
        // return filteredSessionList
      }
      
    },
    [allSessionList, currentEmployee, selectedNotifyType, customAppList] //eslint-disable-line
  );

  const displayCategorySessionStyle = (key: MessageCategoryType) => {
    return {
      display: selectedCategory === key ? "block" : "none"
    };
  };

  if (!allSessionList) {
    return null;
  }
  return (
    <div className="message-container" style={{ display: showSessionTopAll ? "none" : "block" }}>
      {selectedCategory === MessageCategoryType.TIME && (
        <div style={displayCategorySessionStyle(MessageCategoryType.TIME)} id="session_time">
          {getCategorySessionList(MessageTimeCategory.EARLIER).length === 0 &&
          getCategorySessionList(MessageTimeCategory.TODAY).length === 0 ? (
            <NoDataTips type={selectedNotifyType} />
          ) : (
            <SessionCategory
              id="category_time.all"
              title={t("category_time.all")}
              dataList={getCategorySessionList(MessageTimeCategory.ALL)}
              sessionHeight={sessionItem.height}
            />
          )}
        </div>
      )}
      {selectedCategory === MessageCategoryType.TYPE && (
        <div style={displayCategorySessionStyle(MessageCategoryType.TYPE)} id="session_type">
          {/* 群组消息会话 */}
          <SessionCategory
            id="category_type.group"
            title={t("category_type.group")}
            dataList={getCategorySessionList(MessageTypeCategory.GROUP)}
            sessionHeight={sessionItem.height}
          />
          {/* 单聊消息会话 */}
          <SessionCategory
            id="category_type.single"
            title={t("category_type.single")}
            dataList={getCategorySessionList(MessageTypeCategory.SINGLE)}
            sessionHeight={sessionItem.height}
          />
          {/* 通知消息会话 */}
          <SessionCategory
            id="category_type.notice"
            title={t("category_type.notice")}
            dataList={getCategorySessionList(MessageTypeCategory.NOTICE)}
            sessionHeight={sessionItem.height}
          />
          {/* 免打扰消息会话 */}
          <SessionCategory
            id="category_type.no_disturbing"
            title={t("category_type.no_disturbing")}
            dataList={getCategorySessionList(MessageTypeCategory.NODISTURBING)}
            sessionHeight={sessionItem.height}
          />
        </div>
      )}
    </div>
  );
}

function mapStateToProps({ chat }: any) {
  const {
    atCount,
    unReadCount,
    selectedNotifyType,
    selectedCategory,
    sessionStatusMap,
    loadAllSessionListEnd,
    selectedSession,
    sessionScrollIndex,
    sessionUnReadList,
    aiNoticeSessionList,
    customAppList
  } = chat as ChatState;
  return {
    atCount,
    unReadCount,
    selectedNotifyType,
    selectedCategory,
    sessionStatusMap,
    loadAllSessionListEnd,
    selectedSession,
    sessionScrollIndex,
    sessionUnReadList,
    aiNoticeSessionList,
    customAppList
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    async reSortAllSessionList(data: { allSessionList: SessionProps[] }) {
      await dispatch({ type: "chat/reSortAllSessionList", payload: data });
    },
    updatePageLoadState(data: {
      rightLoadState: CompDataLoadState;
      rightPageType: DefaultPageType | null;
    }) {
      setTimeout(() => {
        dispatch({ type: "app/updatePageLoadState", payload: data });
      });
    },
    setSessionScrollIndex: (data: any) => {
      dispatch({ type: "chat/setSessionScrollIndex", payload: data });
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SessionList);
